module.exports = __webpack_public_path__ + "static/img/download.38b7ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/six/download.png
// module id = 0mmT
// module chunks = 1